import { CANAL_PLUS_REGEXP } from '../constants';

export default (url: string) => {
  const canalPlusRegex = new RegExp(CANAL_PLUS_REGEXP);
  return canalPlusRegex.test(url);
};
